<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>《维西之王》邀你登临伟大航路之巅，争夺属于你的海域霸权，成为执掌深海秘宝的航海王！扬帆起航吧，无需漫长等待，无需繁琐养成，指尖轻触，即刻奔赴热血征程！这里有你熟悉的草帽团羁绊，有未解锁的海域传说，更有一船忠诚伙伴，陪你闯过风暴、踏平荆棘，解锁航海王世界的无限可能！</p>
    <!-- <pre> -->
    <h2 class="title" style="margin-bottom: 0px">游戏特色</h2>
    <div class="content">
      <div class="content-item">
        <h4>【颜值拉满-精细打磨】</h4>
        高精度建模打磨每一处细节，贴合角色性格精细勾勒皮肤纹理与服装质感，打破传统卡牌审美局限。御姐风情的海贼女王、酷帅不羁的智勇强者、萌纯软嫩的治愈伙伴、暗黑诡秘的神秘航海家，风格全覆盖，颜值党直接狂喜！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【福利拉满-开局即巅峰】</h4>
        新服专属福利重磅来袭，登录即送UR尼卡路飞，开局狂送千抽，轻松集结强力伙伴，无需肝度碾压，零门槛解锁深海冒险乐趣！多重副本暗藏惊喜彩蛋，既有热血激昂的BOSS对决，也有考验策略的秘境探险，能抗能打更有料，每一次航行都有新惊喜，解锁航海王世界的隐藏传说！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【动漫复刻-沉浸剧情】</h4>
        深度还原航海王原版剧情，从罗格镇的誓言到和之国的决战，从黄金乡的秘宝到推进城的突围，全角色剧情掌上完整呈现，3D立体复刻名场面，全景技能特效还原伙伴招牌招式，每一场战斗都像置身动漫正片，重温热血与感动，书写属于你的航海史诗！
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【快节奏对战-爽感翻倍】</h4>
        打破传统卡牌拖沓桎梏，主打“短平快”策略对战，简化冗余操作，保留核心博弈乐趣，每局战斗高效利落，碎片时间也能畅快开玩。无需复杂计算，一键搭配阵容，技能连招流畅衔接，全屏特效炸裂，既能体验策略搭配的烧脑快感，也能收获一击制胜的极致爽感，新手也能快速上手，轻松Carry全场！
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
